module.exports = __webpack_public_path__ + "img/ios1icon7.03ddef73.png";